module.exports = __webpack_public_path__ + "img/rowA.8b2cb3a4.png";